// localStorage-backed New Relic config (#258) — a per-browser convenience,
// never bundled, same pattern as load-generator-ui's storage.ts (#118).

import type { NrConfig } from "./newrelic";

const K_NR_URL = "admin.newRelicUrl";

export function loadNrConfig(): NrConfig {
  return { baseUrl: localStorage.getItem(K_NR_URL) ?? "" };
}

export function saveNrConfig(cfg: NrConfig): void {
  const base = cfg.baseUrl.trim().replace(/\/+$/, "");
  if (base === "") {
    localStorage.removeItem(K_NR_URL);
  } else {
    localStorage.setItem(K_NR_URL, base);
  }
}
